@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Void Transaction</h5>
            </div>
            <hr />
            <div class="row">
                <div class="col-12 text-start">
                    <ul class="nav nav-tabs custom-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-bs-toggle="tab" href="#voidTransaction">Void Transaction</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane fade show active" [formGroup]="TransactionSearchForm" id="voidTransaction">
                            <div class="p-3">

                                <ul class="Receipt-list mt-2">
                                    <li>
                                        <label><input type="radio" formControlName="ByReceipt" class="form-check-input"
                                                (click)="clearVendorSearch()" [value]="true" i18n>&nbsp;Receipt
                                            Id</label>
                                    </li>
                                    <li>
                                        <ejs-dropdownlist id='ReceiptId' [dataSource]='AccountReciepts'
                                            formControlName="ReceiptId" [fields]='DropDownReceiptfields'
                                            i18n-placeholder placeholder='Select Receipt'></ejs-dropdownlist>
                                    </li>
                                    <li>
                                        <ejs-datepicker format='MM/dd/yyyy' formControlName="ReceiptDate"
                                            [strictMode]="true" class="form-control p-0"
                                            [max]="maxDate"></ejs-datepicker>
                                    </li>
                                </ul>
                                <ul class="Vendor-list mt-2">
                                    <li>
                                        <label><input type="radio" formControlName="ByReceipt" class="form-check-input"
                                                [value]="false" i18n>&nbsp;{{'Vendor ID' | wordReplace}}</label>
                                    </li>
                                    <li>
                                        <input type="text" formControlName="MarketVendorId"
                                            (change)="MarketVendorIdChange()" class="form-control"
                                            [readonly]="TransactionSearchForm.get('ByReceipt')?.value">
                                    </li>
                                    <li>
                                        <div class="input-group">
                                            <div class="input-group me-2">
                                                <input type="text" id="vendorName" class="form-control form-control-sm"
                                                    formControlName="VendorName" readonly>
                                                <button type="button" class="btn btn-primary" style="min-width: 45px;"
                                                    data-bs-toggle="modal" data-bs-target="#vendorSearchModal"
                                                    [disabled]="TransactionSearchForm.get('ByReceipt')?.value">
                                                    <img src="./assets/images/search.svg" class="img-fluid" />
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                    </li>
                                </ul>
                                <div [formGroup]="VoidTransactionForm">
                                    <div class="row">
                                        <div class="col-12 text-start mt-2">
                                            <label for="txtVoidReason" class="mb-1">Void Reason</label>
                                            <textarea class="form-control" formControlName="ReasonToVoid"
                                                id="txtVoidReason"></textarea>
                                        </div>
                                    </div>
                                    <div class="Void-list m-2 d-flex"
                                        *ngIf="TransactionDetails.IsPaymentTransaction && !HasDeletedTransactions">
                                        <span clas="d-inline"><i class="fa fa-check-square m-2" style="color: green;"
                                                aria-hidden="true"></i>Payment Transaction</span>
                                    </div>
                                    <div class="Void-list m-2 d-flex" *ngIf="HasDeletedTransactions">
                                        <span clas="d-inline"><i class="fa fa-window-close m-2"
                                                style="color: rgb(212, 4, 4);" aria-hidden="true"></i>Voiding the
                                            transaction not possible, One or more records of this transaction is deleted
                                        </span>
                                    </div>
                                    <hr />
                                    <div class="row">
                                        <div class="col-12 text-start mt-2">
                                            <h6 class="fw-semibold mb-3">Transactions</h6>
                                            <ejs-grid #gridTransactions [dataSource]="TransactionDetails.RentalRecords"
                                                class="Table_Height_store table-striped table-ipad"
                                                [allowSorting]="false" [allowFiltering]="false" height="200">
                                                <e-columns>
                                                    <e-column field="BoothNumber" headerText="{{ 'Booth #' | wordReplace }}"
                                                        width="120"></e-column>
                                                    @if(noLayout == false){
                                                        <e-column field="BoothType" headerText="{{ 'Booth Type' | wordReplace }}"
                                                        width="150"></e-column>
                                                    }
                                                    <e-column field="ProductDescription" headerText="Product"
                                                        width="150"></e-column>
                                                    <!-- <e-column field="MarketDay" [headerText]="MarketDayHeaderName"
                                                        width="120"></e-column> -->
                                                    <e-column field="RentalPeriodStart" headerText="Rental Start Date"
                                                        width="160" textAlign="Left">
                                                        <ng-template #template let-data>
                                                            <span class="dataName" title={{data.RentalPeriodStart}}>
                                                                {{data.RentalPeriodStart}} </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="RentalPeriodEnd" headerText="Period" width="120">
                                                        <ng-template #template let-data>
                                                            <span class="dataName" title={{data.RentalPeriodEnd}}>
                                                                {{data.RentalPeriodEnd}} </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column headerText="Rent" width="120" textAlign="Right">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{
                                                                data.RentalCharges | customCurrency }} </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="TotalRentalCharges" headerText="Total" width="120"
                                                        textAlign="Right">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.TotalRentalCharges >= 0 ?
                                                                (data.TotalRentalCharges | currency) :
                                                                '('+(data.TotalRentalCharges * -1 | currency)+')'}}
                                                            </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="BoothPriorBalance" headerText="Bal Fwd" width="120"
                                                        textAlign="Right" *ngIf="shouldShowBalanceColumns">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.BoothPriorBalance >= 0 ?
                                                                (data.BoothPriorBalance | currency) :
                                                                '('+(data.BoothPriorBalance * -1 | currency)+')'}}
                                                            </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="Due" headerText="Due" width="120" textAlign="Right"
                                                        *ngIf="shouldShowBalanceColumns">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.Due >= 0 ?
                                                                (data.Due | currency) :
                                                                '('+(data.Due * -1 | currency)+')'}}
                                                            </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="Payment" headerText="Payment" width="120"
                                                        textAlign="Right" *ngIf="shouldShowBalanceColumns">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.Payment >= 0 ?
                                                                (data.Payment | currency) :
                                                                '('+(data.Payment * -1 | currency)+')'}}
                                                            </span>
                                                        </ng-template>
                                                    </e-column>
                                                </e-columns>
                                            </ejs-grid>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-lg-8 text-start mt-2">
                                            <ejs-grid #gridItems [dataSource]='TransactionDetails.RentalItems'
                                                class="Table_Height_store table-striped table-ipad"
                                                [allowSorting]="false" [allowFiltering]="false" height="200">
                                                <e-columns>
                                                    <e-column field="Description" headerText="Item"
                                                        width="150"></e-column>
                                                    <e-column field="IsReserved" headerText="Rec" width="80"
                                                        textAlign="Center">
                                                        <ng-template #template let-data>
                                                            <i class="bi bi-check-square-fill checkBoxClass"
                                                                *ngIf="data.IsReserved"></i>
                                                            <i class="bi bi-square checkBoxClass"
                                                                *ngIf="!data.IsReserved"></i>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="UnitPrice" headerText="Charge" width="120"
                                                        textAlign="Right" format="C2">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.UnitPrice >= 0 ?
                                                                (data.UnitPrice
                                                                | currency) : '('+(data.UnitPrice* -1 | currency)+')'}}
                                                            </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="Quantity" headerText="Qty" width="80"
                                                        textAlign="Center"></e-column>
                                                    <e-column field="Reference" headerText="Reference"
                                                        width="130"></e-column>
                                                    <e-column field="RentalPeriod2" headerText="Period"
                                                        width="120"></e-column>
                                                    <e-column field="TotalAmount" headerText="Total" width="120"
                                                        textAlign="Right">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.TotalAmount >= 0 ?
                                                                (data.TotalAmount | currency) : '('+(data.TotalAmount*
                                                                -1 |
                                                                currency)+')'}} </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="BoothPriorBalance" headerText="Bal Fwd" width="120"
                                                        textAlign="Right" *ngIf="shouldShowBalanceColumns">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.BoothPriorBalance >= 0 ?
                                                                (data.BoothPriorBalance | currency) :
                                                                '('+(data.BoothPriorBalance * -1 | currency)+')'}}
                                                            </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="Due" headerText="Due" width="120" textAlign="Right"
                                                        *ngIf="shouldShowBalanceColumns">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.Due >= 0 ?
                                                                (data.Due | currency) :
                                                                '('+(data.Due * -1 | currency)+')'}}
                                                            </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field="Payment" headerText="Payment" width="120"
                                                        textAlign="Right" *ngIf="shouldShowBalanceColumns">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.Payment >= 0 ?
                                                                (data.Payment | currency) :
                                                                '('+(data.Payment * -1 | currency)+')'}}
                                                            </span>
                                                        </ng-template>
                                                    </e-column>
                                                </e-columns>
                                            </ejs-grid>
                                        </div>
                                        <div class="col-md-12 col-lg-4 text-start mt-2">
                                            <ejs-grid #gridPlans class="Table_Height_store table-striped table-ipad"
                                                [dataSource]="TransactionDetails.DiscountPlans" [allowSorting]="false"
                                                [allowFiltering]="false" height="200">
                                                <e-columns>
                                                    <e-column field='DiscountPlanId' headerText='Plan ID'
                                                        textAlign='left' width=90>
                                                    </e-column>
                                                    <e-column field='Discount' headerText='Discount' textAlign='left'
                                                        width=90>
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.Discount >= 0 ?
                                                                (data.Discount | currency) :
                                                                '('+(data.Discount * -1 | currency)+')'}} </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field='Tax' headerText='Sales Tax' textAlign='left'
                                                        width=120 *ngIf="DiscountHasTax ">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.Tax >= 0 ?
                                                                (data.Tax | currency) :
                                                                '('+(data.Tax * -1 | currency)+')'}} </span>
                                                        </ng-template>
                                                    </e-column>
                                                    <e-column field='SecLvlTax'
                                                        [headerText]="this.TaxSettings.SecondTaxName != '' ? this.TaxSettings.SecondTaxName : 'Second Level Tax'"
                                                        textAlign='left' width=120 *ngIf="DiscountHasSecTax ">
                                                        <ng-template #template let-data>
                                                            <span class="dataName"> {{data.SecLvlTax | customCurrency }}
                                                            </span>
                                                        </ng-template>
                                                    </e-column>
                                                </e-columns>
                                            </ejs-grid>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-lg-8 text-start mt-2">
                                            <div class="card shadow-sm">
                                                <div class="card-body">
                                                    <h6 class="fw-bold mb-3">Charges</h6>
                                                    <div class="row g-3">
                                                        <div class="col-md-6">
                                                            <label class="form-label">Rental Charges</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="TransactionDetails.RentalCharges >= 0 ? (TransactionDetails.RentalCharges | currency) : '('+(TransactionDetails.RentalCharges *-1 | currency)+')'"
                                                                disabled>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="form-label">Cash Adjustment</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="TransactionDetails.CashAdjustment >= 0 ? (TransactionDetails.CashAdjustment | currency) : '('+(TransactionDetails.CashAdjustment *-1| currency)+')'  "
                                                                disabled>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="form-label">Other Charges</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="TransactionDetails.RentalOtherCharges >= 0 ? (TransactionDetails.RentalOtherCharges | currency) : '('+(TransactionDetails.RentalOtherCharges *-1| currency)+')'"
                                                                disabled>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="form-label">Check Adjustment</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="TransactionDetails.CheckAdjustmentAmount >= 0 ? (TransactionDetails.CheckAdjustmentAmount | currency) : '('+(TransactionDetails.CheckAdjustmentAmount *-1| currency)+')' "
                                                                disabled>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="form-label">Deposit Amount</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="TransactionDetails.DepositAmount >= 0 ? (TransactionDetails.DepositAmount | currency) : '('+(TransactionDetails.DepositAmount*-1 | currency)+')'"
                                                                disabled>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="form-label">Check Number</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="TransactionDetails.CheckNumber" disabled>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <label class="form-label">Sales Tax</label><br>
                                                                    @if(!TransactionDetails.SalesTaxEnabled){
                                                                    <span class="text-danger">Not Applicable</span>
                                                                    }@else{
                                                                    <input type="text" class="form-control text-end"
                                                                        [value]="TransactionDetails.SalesTax >= 0 ? (TransactionDetails.SalesTax | currency) : '('+(TransactionDetails.SalesTax*-1 | currency)+')'"
                                                                        disabled>
                                                                    }
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <label class="form-label">Second Level
                                                                        Tax</label><br>
                                                                    @if(!TransactionDetails.SecLvlSalesTaxEnabled){
                                                                    <span class="text-danger">Not Applicable</span>
                                                                    }@else{
                                                                    <input type="text" class="form-control text-end"
                                                                        [value]="TransactionDetails.SecLvlSalesTax >= 0 ? (TransactionDetails.SecLvlSalesTax | currency) : '('+(TransactionDetails.SecLvlSalesTax *-1 | currency)+')'"
                                                                        disabled>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="form-label">Discount</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="TransactionDetails.Discount >= 0 ? (TransactionDetails.Discount | currency) : '('+(TransactionDetails.Discount*-1 | currency)+')'  "
                                                                disabled>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="form-label">CC / DC Adjustment</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="TransactionDetails.CCAdjustmentAmount >= 0 ? (TransactionDetails.CCAdjustmentAmount | currency) : '('+(TransactionDetails.CCAdjustmentAmount*-1 | currency)+')' "
                                                                disabled>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label class="form-label">Direct Debit Amount</label>
                                                            <input type="text" class="form-control text-end"
                                                                [value]="TransactionDetails.DirectDebitPayment >= 0 ? (TransactionDetails.DirectDebitPayment | currency) : '('+(TransactionDetails.DirectDebitPayment*-1 | currency)+')' "
                                                                disabled>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-4 text-start mt-2">
                                            <div class="form-check mb-2">
                                                <input class="form-check-input" type="checkbox" id="displayReceipt"
                                                    formControlName="DisplayReceipt">
                                                <label class="form-check-label" for="displayReceipt">Display
                                                    Receipt</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="printReceipt"
                                                    formControlName="PrintReceipt">
                                                <label class="form-check-label" for="printReceipt">Print Receipt</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 text-end my-2">
                                            <button class="btn btnAS me-1" (click)="CheckCCRefund()">Void</button>
                                            <button class="btn btn-orange" (click)="Close()">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="vendorSearchModal" #vendorSearchModal tabindex="-1" aria-labelledby="vendorSearchLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header d-flex modal-headerNewBooths">
                <h4 class="modal-title font-weight-normal" id="exampleModalLabel" i18n>{{'Vendor Search' | wordReplace}}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body modal-bodyNewBooths">
                <app-vendor-search [isVendorPopUp]="true" [VendorFilterOption]="VendorFilterOption"
                    (vendorSearchRoute)="vendorSearchResult($event)">
                </app-vendor-search>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="RefundModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    CC Refund -
                    ({{ TransactionSearchForm.get('VendorName')?.value }})
                </h4>
                <button type="button" class="btn-close" (click)="closeModalById('RefundModal')">
                </button>
            </div>
            <div class="modal-body" [formGroup]="RefundCCForm">
              <div *ngIf="!ProcessRefund">
                <div class="row mt-3">
                  <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
                    <div class="row ">
                      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 text-left">
                        <label> Total Amount</label>
                      </div>
                      <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left">
                        <input type="text"
                               [value]="RefundCCForm.get('TotalCCAmount').value >= 0 ? (RefundCCForm.get('TotalCCAmount').value | currency) : '('+(RefundCCForm.get('TotalCCAmount').value*-1 | currency)+')' "
                               disabled>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
                    <div class="row ">
                      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 text-left">
                        <label>{{'Vendor ID' | wordReplace}}</label>
                      </div>
                      <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left">
                        <input type="text" [value]="RefundCCForm.get('MarketVendorId').value" disabled>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="ProcessRefund && IsOpenEdgeExpress">
                <app-payment [voidPayment]="true" [VendorId]="this.RefundCCForm.get('SeqVendorId').value"
                             [VerifoneId]="PaymentTransactionInfo.VerifoneRecordId"
                             (PaymentResponse)="PaymentRespond($event)"></app-payment>
              </div>
              <div *ngIf="ProcessRefund && IsStrip">
                <app-stripe-payment [voidPayment]="true" [VendorId]="this.RefundCCForm.get('SeqVendorId').value"
                                    [VerifoneId]="PaymentTransactionInfo.VerifoneRecordId"
                                    (PaymentResponse)="PaymentRespond($event)"></app-stripe-payment>
              </div>
            </div>
            <div class="modal-footer text-center">
                <button type="button" class="btn btn-outline-primary" (click)="Refund()">
                    Void
                </button>
                <button type="button" class="btn btn-danger" (click)="closeModalById('RefundModal')">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="viewReceiptModal" tabindex="-1" aria-labelledby="viewReceiptModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="viewReceiptModalLabel">Preview</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="500px" frameborder="0"></iframe>
            </div>
            <div class="modal-footer">
                <button class="btn btn-orange" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalOpenCash" #modalOpenCash aria-hidden="true" aria-labelledby="modalOpenCashLabel"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-header">

            </div>
            <div class="modal-body">
                <app-ops-opening-cash-drawer-amount *ngIf="openCashNotSet" [hideOpenCashTopMenu]="hideOpenCashTopMenu"
                    (openCashSaved)="openCashSaved($event)"></app-ops-opening-cash-drawer-amount>
            </div>
            <div class="modal-footer">
                <button class="btn btn-orange" (click)="btnCloseOpenCash()">Cancel</button>
            </div>
        </div>
    </div>
</div>
